/**
 * None
 */
class None {
  /**
   * sign
   */
  sign () {
    return Promise.resolve('')
  }

  /**
   * verify
   */
  verify () {
    // this will never get called. but you looked.
  }
}

/**
 * Export
 */
module.exports = None
